<template>
  <div class="pagina ativa" id="paginaHistoricoPropostas">
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:20px;border-bottom:2px solid #4a5c2f;padding-bottom:10px;">
      <div style="display:flex;align-items:center;gap:8px;font-size:22px;font-weight:bold;color:#4a5c2f;"><History :size="22" /> Histórico de Propostas</div>
      <button @click="carregarHistorico" style="display:inline-flex;align-items:center;gap:5px;margin:0;padding:8px 18px;font-size:13px;"><RefreshCw :size="13" /> Atualizar</button>
    </div>

    <div style="background:white;border-radius:10px;padding:16px 20px;box-shadow:0 2px 8px rgba(0,0,0,0.07);margin-bottom:20px;display:flex;gap:14px;flex-wrap:wrap;align-items:flex-end;">
      <div>
        <label style="font-size:11px;font-weight:bold;color:#888;display:block;margin-bottom:4px;text-transform:uppercase;">Cliente</label>
        <input type="text" v-model="filtroCliente" placeholder="Nome do cliente..." style="width:200px;padding:8px 10px;border:1px solid #ddd;border-radius:6px;font-size:13px;margin:0;" />
      </div>
      <div>
        <label style="font-size:11px;font-weight:bold;color:#888;display:block;margin-bottom:4px;text-transform:uppercase;">Data de</label>
        <input type="date" v-model="filtroDataInicio" style="width:155px;padding:8px 10px;border:1px solid #ddd;border-radius:6px;font-size:13px;margin:0;" />
      </div>
      <div>
        <label style="font-size:11px;font-weight:bold;color:#888;display:block;margin-bottom:4px;text-transform:uppercase;">Até</label>
        <input type="date" v-model="filtroDataFim" style="width:155px;padding:8px 10px;border:1px solid #ddd;border-radius:6px;font-size:13px;margin:0;" />
      </div>
      <div v-if="ehAdmin">
        <label style="font-size:11px;font-weight:bold;color:#888;display:block;margin-bottom:4px;text-transform:uppercase;">Vendedor</label>
        <select v-model="filtroVendedor" style="width:180px;padding:8px 10px;border:1px solid #ddd;border-radius:6px;font-size:13px;margin:0;">
          <option value="">Todos</option>
          <option v-for="v in vendedoresDisponiveis" :key="v" :value="v">{{ v }}</option>
        </select>
      </div>
      <div>
        <label style="font-size:11px;font-weight:bold;color:#888;display:block;margin-bottom:4px;text-transform:uppercase;">&nbsp;</label>
        <button @click="limparFiltros" style="margin:0;padding:8px 16px;font-size:13px;background:#888;">Limpar</button>
      </div>
    </div>

    <div class="grid-cards" style="margin-bottom:20px;">
      <div class="card"><div class="card-label">Total de Propostas</div><div class="card-valor">{{ dadosFiltrados.length }}</div></div>
      <div class="card"><div class="card-label">Clientes Únicos</div><div class="card-valor">{{ clientesUnicosCount }}</div></div>
      <div class="card"><div class="card-label">Última Proposta</div><div class="card-valor" style="font-size:15px;">{{ ultimaPropostaData }}</div></div>
    </div>

    <div v-if="carregando"><p style="color:#aaa;text-align:center;padding:40px;">Carregando...</p></div>
    <div v-else-if="!clientesOrdenados.length"><p style="color:#aaa;text-align:center;padding:40px;">Nenhuma proposta encontrada.</p></div>
    <div v-else>
      <div v-for="cliente in clientesOrdenados" :key="cliente" style="background:white;border-radius:12px;box-shadow:0 2px 8px rgba(0,0,0,0.07);margin-bottom:16px;overflow:hidden;">
        <div style="background:#f5f7f0;padding:12px 18px;border-bottom:1px solid #e8ede0;display:flex;align-items:center;gap:10px;">
          <UserRound :size="18" style="color:#2e3a18;" />
          <span style="font-weight:bold;color:#2e3a18;font-size:15px;">{{ cliente }}</span>
          <span style="font-size:12px;color:#888;margin-left:4px;">{{ porCliente[cliente].length }} versão{{ porCliente[cliente].length !== 1 ? 'ões' : '' }}</span>
        </div>
        <div style="padding:12px 18px;">
          <div v-for="id in idsOrdenadosPorCliente(cliente)" :key="id" style="border:1px solid #eee;border-radius:10px;padding:14px;margin-bottom:10px;">
            <div style="display:flex;align-items:flex-start;justify-content:space-between;flex-wrap:wrap;gap:8px;">
              <div>
                <div style="font-size:14px;font-weight:bold;color:#333;">{{ ultimaVersao(cliente, id).titulo }}</div>
                <div style="font-size:12px;color:#888;margin-top:3px;">{{ cartasDesc(ultimaVersao(cliente, id)) }}</div>
                <div style="font-size:11px;color:#aaa;margin-top:4px;">Última versão: {{ ultimaVersao(cliente, id).dataVersao }}{{ ehAdmin ? ' · ' + ultimaVersao(cliente, id).vendedor : '' }}</div>
              </div>
              <div style="display:flex;gap:6px;align-items:center;flex-wrap:wrap;">
                <button @click="verProposta(cliente, id, 'ultima')" style="display:inline-flex;align-items:center;gap:4px;margin:0;padding:6px 14px;font-size:12px;background:#4a5c2f;"><Eye :size="13" /> Ver</button>
                <button @click="editarProposta(cliente, id)" style="display:inline-flex;align-items:center;gap:4px;margin:0;padding:6px 14px;font-size:12px;background:#f39c12;"><Pencil :size="13" /> Editar</button>
                <button v-if="ehAdmin" @click="confirmarExcluir(ultimaVersao(cliente, id))" style="display:inline-flex;align-items:center;justify-content:center;margin:0;padding:6px 12px;font-size:12px;background:#c0392b;"><Trash2 :size="13" /></button>
              </div>
            </div>
            <div v-if="versoesPorId(cliente, id).length > 1" style="margin-top:10px;border-top:1px solid #f5f5f5;padding-top:8px;">
              <div style="font-size:10px;color:#aaa;font-weight:bold;text-transform:uppercase;letter-spacing:.04em;margin-bottom:6px;">Histórico de versões</div>
              <div style="display:flex;flex-direction:column;gap:4px;">
                <div v-for="v in versoesPorId(cliente, id)" :key="v.versao" style="display:flex;align-items:center;justify-content:space-between;background:#f9f9f9;border-radius:6px;padding:5px 10px;">
                  <span style="font-size:11px;color:#555;"><span style="background:#4a5c2f;color:white;padding:1px 7px;border-radius:10px;font-size:10px;margin-right:6px;">v{{ v.versao }}</span>{{ v.dataVersao }}</span>
                  <button @click="verProposta(cliente, id, v.versao)" style="margin:0;padding:3px 10px;font-size:11px;background:#eee;color:#555;border:none;border-radius:5px;cursor:pointer;">Ver</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL VISUALIZAR PROPOSTA SALVA -->
    <div v-if="modalVerAberto" class="app-drawer-overlay">
      <div class="app-drawer" style="padding:0;max-width:760px;">
        <div style="display:flex;align-items:center;justify-content:space-between;padding:16px 20px;background:#4a5c2f;">
          <span style="font-size:15px;font-weight:bold;color:white;">{{ modalVerTitulo }}</span>
          <div style="display:flex;gap:8px;">
            <button @click="editarPropostaDoModal" style="display:inline-flex;align-items:center;gap:4px;margin:0;padding:6px 14px;font-size:12px;background:#f39c12;border:none;border-radius:5px;color:white;cursor:pointer;"><Pencil :size="13" /> Editar (nova versão)</button>
            <button @click="modalVerAberto = false" style="display:inline-flex;align-items:center;justify-content:center;background:rgba(255,255,255,0.2);border:none;color:white;width:28px;height:28px;border-radius:50%;cursor:pointer;padding:0;margin:0;"><X :size="13" /></button>
          </div>
        </div>
        <div style="padding:20px;flex:1;overflow-y:auto;">
          <div style="display:flex;gap:16px;flex-wrap:wrap;margin-bottom:16px;padding:10px 14px;background:#f8f9f6;border-radius:8px;">
            <div style="font-size:12px;color:#555;"><strong style="color:#333;">Vendedor:</strong> {{ modalVerProposta.vendedor }}</div>
            <div style="font-size:12px;color:#aaa;">|</div>
            <div style="font-size:12px;color:#555;"><strong style="color:#333;">Criado:</strong> {{ modalVerDataCriacao }}</div>
            <div style="font-size:12px;color:#aaa;">|</div>
            <div style="font-size:12px;color:#555;"><strong style="color:#333;">Esta versão:</strong> {{ modalVerDataVersao }}</div>
          </div>
          <div v-html="modalVerHtml"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGet, apiDelete, getSession, getNomeEmpresaCache } from '../api'
import { montarPreviewSalvaHtml, setPendingEditProposta } from '../propostaHelpers'
import { History, RefreshCw, UserRound, Eye, Pencil, Trash2, X } from 'lucide-vue-next'

export default {
  components: { History, RefreshCw, UserRound, Eye, Pencil, Trash2, X },
  name: 'PaginaHistoricoPropostas',
  data() {
    return {
      carregando: false,
      todasPropostas: [],
      filtroCliente: '',
      filtroDataInicio: '',
      filtroDataFim: '',
      filtroVendedor: '',
      modalVerAberto: false,
      modalVerTitulo: '',
      modalVerProposta: {},
      modalVerHtml: '',
      beneficiosConfig: { texto: '', visivel: false }
    }
  },
  computed: {
    ehAdmin() { return getSession().perfil === 'admin' },
    nomeUsuario() { return getSession().nome || getSession().usuario },
    vendedoresDisponiveis() {
      const vends = {}
      this.todasPropostas.forEach(p => { vends[p.vendedor] = true })
      return Object.keys(vends).sort()
    },
    dadosFiltrados() {
      const fc = (this.filtroCliente || '').toLowerCase()
      const fd = this.filtroDataInicio
      const fa = this.filtroDataFim
      const fv = this.filtroVendedor
      let dados = this.todasPropostas.slice()
      if (fc) dados = dados.filter(p => p.cliente.toLowerCase().indexOf(fc) > -1)
      if (fv) dados = dados.filter(p => p.vendedor === fv)
      function _parseDataBR(s) { if (!s) return null; const p = s.split(' ')[0].split('/'); return p.length === 3 ? new Date(+p[2], +p[1] - 1, +p[0]) : null }
      if (fd) { const dfd = new Date(fd); dados = dados.filter(p => { const d = _parseDataBR(p.dataVersao); return d && d >= dfd }) }
      if (fa) { const dfa = new Date(fa); dfa.setHours(23, 59, 59); dados = dados.filter(p => { const d = _parseDataBR(p.dataVersao); return d && d <= dfa }) }
      return dados
    },
    clientesUnicosCount() {
      const set = {}
      this.dadosFiltrados.forEach(p => { set[p.cliente] = true })
      return Object.keys(set).length
    },
    ultimaPropostaData() {
      if (!this.dadosFiltrados.length) return '--'
      return this._fmtDataHP(this.dadosFiltrados[0].dataVersao)
    },
    porCliente() {
      const agrupado = {}
      this.dadosFiltrados.forEach(p => {
        if (!agrupado[p.cliente]) agrupado[p.cliente] = []
        agrupado[p.cliente].push(p)
      })
      return agrupado
    },
    clientesOrdenados() { return Object.keys(this.porCliente).sort() },
    modalVerDataCriacao() { return this._limparData(this.modalVerProposta.dataCriacao) },
    modalVerDataVersao() { return this._limparData(this.modalVerProposta.dataVersao) }
  },
  created() {
    this.carregarHistorico()
    this.carregarBeneficios()
  },
  methods: {
    async carregarBeneficios() {
      try {
        const r = await apiGet('config/get', { chave: 'BENEFICIOS_PROPOSTA' })
        if (r.sucesso && r.valor) { try { this.beneficiosConfig = JSON.parse(r.valor) } catch (e) { this.beneficiosConfig = { texto: '', visivel: false } } }
      } catch (e) { /* ignore */ }
    },
    async carregarHistorico() {
      this.carregando = true
      try {
        const r = await apiGet('propostas/listar')
        this.todasPropostas = r.sucesso ? (r.propostas || []) : []
      } catch (e) { this.todasPropostas = [] } finally { this.carregando = false }
    },
    limparFiltros() {
      this.filtroCliente = ''
      this.filtroDataInicio = ''
      this.filtroDataFim = ''
      this.filtroVendedor = ''
    },
    _fmtDataHP(s) {
      if (!s) return '--'
      if (/^\d{2}\//.test(s)) return s.substring(0, 10)
      if (/^\d{4}-/.test(s)) { const p = s.substring(0, 10).split('-'); return p[2] + '/' + p[1] + '/' + p[0] }
      try { const dt = new Date(s); if (!isNaN(dt.getTime())) return dt.toLocaleDateString('pt-BR') } catch (e) { /* ignore */ }
      return s.substring(0, 10)
    },
    _limparData(s) {
      if (!s) return '—'
      if (/^\d{2}\/\d{2}\/\d{4}/.test(s)) return s.substring(0, 16)
      if (/^\d{4}-\d{2}-\d{2}/.test(s)) { const p = s.substring(0, 10).split('-'); return p[2] + '/' + p[1] + '/' + p[0] }
      try { const dt = new Date(s); if (!isNaN(dt.getTime())) return dt.toLocaleDateString('pt-BR') + ' ' + dt.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }) } catch (e) { /* ignore */ }
      return s
    },
    versoesPorId(cliente, id) {
      return (this.porCliente[cliente] || []).filter(p => p.id === id).slice().sort((a, b) => b.versao - a.versao)
    },
    idsOrdenadosPorCliente(cliente) {
      const lista = this.porCliente[cliente] || []
      const porId = {}
      lista.forEach(p => { if (!porId[p.id]) porId[p.id] = []; porId[p.id].push(p) })
      return Object.keys(porId).sort((a, b) => {
        const ua = Math.max(...porId[a].map(p => p.versao))
        const ub = Math.max(...porId[b].map(p => p.versao))
        return ub - ua
      })
    },
    ultimaVersao(cliente, id) {
      return this.versoesPorId(cliente, id)[0]
    },
    cartasDesc(p) {
      if (!p || !p.dados || !p.dados.cartas) return '—'
      return p.dados.cartas.map(c => c.segmento + (c.credito ? (' — R$ ' + c.credito) : '')).join(' · ') || '—'
    },
    verProposta(cliente, id, versao) {
      const todas = this.versoesPorId(cliente, id)
      const p = versao === 'ultima' ? todas[0] : todas.find(x => x.versao === versao)
      if (!p) return
      this.modalVerProposta = p
      this.modalVerTitulo = p.titulo + ' — v' + p.versao
      this.modalVerHtml = montarPreviewSalvaHtml(p.dados, this.beneficiosConfig, this.nomeUsuario, getNomeEmpresaCache())
      this.modalVerAberto = true
    },
    editarProposta(cliente, id) {
      const p = this.ultimaVersao(cliente, id)
      this._irEditar(p)
    },
    editarPropostaDoModal() {
      this._irEditar(this.modalVerProposta)
      this.modalVerAberto = false
    },
    _irEditar(p) {
      if (!p) return
      setPendingEditProposta(p)
      window.dispatchEvent(new CustomEvent('siscon-navigate', { detail: 'proposta' }))
    },
    async confirmarExcluir(p) {
      if (!confirm('Excluir proposta "' + p.titulo + '"? Esta versão será removida permanentemente.')) return
      try {
        const r = await apiDelete('propostas/excluir', { id: p.id, versao: p.versao })
        if (r.sucesso) this.carregarHistorico()
        else alert(r.mensagem || 'Erro ao excluir.')
      } catch (e) { alert('Erro de conexão ao excluir.') }
    }
  }
}
</script>
